<script setup lang="ts">
import { CommandShortcut } from "ls/components/command";
import { CornerDownLeftIcon } from "lucide-vue-next";
</script>

<template>
  <CommandShortcut>
    <CornerDownLeftIcon class="size-4 opacity-0 group-data-highlighted/command:opacity-50" aria-hidden="true" />
  </CommandShortcut>
</template>
